import React, { useState } from 'react';
import { Ofertas } from './menu_turma_ofertas';
import { sigla } from '../../../../shared/utils/formatters/sigla.formatter';
import { Scroll } from '../../../../shared/components/layout_components/scroll';
import { SearchBar } from '../../../../shared/components/search_bar';
import { Container, Titulo, ListaTurma, Turma, NomeTurma, Header } from './styles';

import {
  AlocacaoPageQuery_cursos,
  AlocacaoPageQuery_periodos,
} from '../../../graphql/queries/__generated__/AlocacaoPageQuery';

interface Props {
  cursos?: AlocacaoPageQuery_cursos[];
  periodo: AlocacaoPageQuery_periodos | null;
  ativos: boolean;
}

const Turmas: React.FC<Props> = (props) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const filtrar_cursos = () => {
    return props.cursos
      ? props.cursos.filter((c) => {
          return (
            sigla(c.dsc_nome_curso, c.dsc_sigla_curso)?.toLowerCase().includes(searchTerm.toLowerCase()) &&
            (props.ativos ? c.ativo === props.ativos : true)
          );
        })
      : [];
  };

  return (
    <Container>
      <Header>
        <Titulo>Turmas</Titulo>
        <SearchBar onSearch={setSearchTerm} placeholder='Filtrar turmas...' />
      </Header>

      <Scroll scroll-auto>
        <ListaTurma>
          {filtrar_cursos().map((curso) => (
            <Turma key={curso.id_curso}>
              <NomeTurma>{sigla(curso.dsc_nome_curso, curso.dsc_sigla_curso)}</NomeTurma>
              <Ofertas
                ofertas={curso.ofertas}
                periodo={props.periodo}
                dsc_nome_curso={curso.dsc_nome_curso}
                dsc_sigla_curso={curso.dsc_sigla_curso}
                ativa={props.ativos}
              />
            </Turma>
          ))}
        </ListaTurma>
      </Scroll>
    </Container>
  );
};

export { Turmas };
